// extracted by mini-css-extract-plugin
export default {"mCard":"XB-z","image":"YB-z","imageNoBackground":"ZB-z","fullWidth":"_B-z"};